<!--

Size:
default
large
small

Classes:
primary
secondary
icon
no-label
ghost

State:
:hover / hover
:active / active
:disabled / disabled
:invalid / negative

-->

<!-- <input
  [type]="type"
  [ngClass]="['sp-date-picker', style, state, size]"
  (click)="onClickEvent()"
>
  <i *ngIf="icon" class="icon"></i>
  <img src="icons-line/01-Content-Edition/atomic-bomb.svg" />
  <span>{{ label }}</span> -->
<div class="datepicker-containter">
  <div *ngIf="!range" class="sp-datepicker {{ size }}">
    <div class="sp-datepicker-single">
      <div class="input-container-datepicker">
        <input type="text" class="single-sp-datepicker" *ngIf="!range" [(ngModel)]="singleDateValue" [placeholder]="placeholder" />
        <label>{{ title }}</label>
        <span> <img (click)="openDatePicker()" src="/public/resources/images/icons/calendar-2.svg" /> </span>
        <small> <img (click)="openDatePicker()" src="/public/resources/images/icons/dropdown-arrow-down.svg" /> </small>
      </div>
    </div>
  </div>
  <div *ngIf="range" class="sp-datepicker {{ size }}">
    <div class="sp-datepicker-two-ranges">
      <div class="input-container-datepicker">
        <input class="input-start" (focus)="openDatePicker()" [placeholder]="''" [(ngModel)]="start_value" />
        <label>{{ title }}</label>
        <span> <img (click)="openDatePicker()" src="/public/resources/images/icons/calendar-2.svg" /> </span>
        <small> <img (click)="openDatePicker()" src="/public/resources/images/icons/dropdown-arrow-down.svg" /> </small>
      </div>
      <div class="input-container-datepicker">
        <input class="input-end" (focus)="openDatePicker()" [placeholder]="''" [(ngModel)]="end_value" /> <label>{{ to_title }}</label>
        <span> <img (click)="openDatePicker()" src="/public/resources/images/icons/calendar-2.svg" /> </span>
        <small> <img (click)="openDatePicker()" src="/public/resources/images/icons/dropdown-arrow-down.svg" /> </small>
      </div>
    </div>

    <div dir="ltr" type="text" [ngClass]="['sp-datepicker-input', offset]" [class.sp-datepicker-input--open]="modalRangeOpen">
      <div class="sp-datepicker-calendar"></div>
    </div>
  </div>
</div>
